// BEGIN motorbikeBackpackGalleryRestore20260716
;(function motorbikeBackpackGalleryRestore20260716() {
  var config = {
  "handle": "seibertron-sps-7w-waterproof-leather-carbon-fiber-touchscreen-motorcycle-riding-gloves",
  "entries": [
    {
      "id": "33248147308734",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps7w-color-1782371919990-01.jpg?v=1782371891",
      "alt": "Seibertron SPS-7W waterproof motorcycle gloves in White"
    },
    {
      "id": "33248147341502",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps7w-color-1782371919990-02.jpg?v=1782371891",
      "alt": "Seibertron SPS-7W waterproof motorcycle gloves in Black"
    },
    {
      "id": "33248147374270",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps7w-color-1782371919990-03.jpg?v=1782371891",
      "alt": "Seibertron SPS-7W waterproof motorcycle gloves in Fluorescent Orange"
    },
    {
      "id": "33248147407038",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps7w-color-1782371919990-04.jpg?v=1782371890",
      "alt": "Seibertron SPS-7W waterproof motorcycle gloves in Red"
    },
    {
      "id": "33248147439806",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps7w-color-1782371919990-05.jpg?v=1782371891",
      "alt": "Seibertron SPS-7W waterproof motorcycle gloves in Klein Blue"
    },
    {
      "id": "33248147472574",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/sps7w-color-1782371919990-06.jpg?v=1782371891",
      "alt": "Seibertron SPS-7W waterproof motorcycle gloves in Fluorescent Yellow"
    },
    {
      "id": "33456959422654",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-01-20260716.png?v=1784212171",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-01 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959455422",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-02-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-02 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959488190",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-03-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-03 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959520958",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-04-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-04 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959553726",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-05-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-05 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959586494",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-06-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-06 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959619262",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-07-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-07 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959652030",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-08-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-08 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959684798",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-09-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-09 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959717566",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-10-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-10 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959750334",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-11-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-11 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959783102",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-12-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-12 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959815870",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-13-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-13 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959848638",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-14-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-14 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959881406",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-15-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-15 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959914174",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-16-20260716.png?v=1784212171",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-16 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959946942",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-17-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-17 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    },
    {
      "id": "33456959979710",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps7w-lifestyle-18-20260716.png?v=1784212170",
      "alt": "batch:sps7w-gallery-20260716 | role:lifestyle-18 | Seibertron SPS-7W waterproof motorcycle riding gloves lifestyle image"
    }
  ],
  "variants": [
    {
      "id": "47754298917054",
      "title": "White / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "White",
        "Youth L"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754298949822",
      "title": "White / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "White",
        "Youth XL"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754298982590",
      "title": "White / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "White",
        "Adult S"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754299015358",
      "title": "White / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "White",
        "Adult M"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754299048126",
      "title": "White / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "White",
        "Adult L"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754299080894",
      "title": "White / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "White",
        "Adult XL"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754299113662",
      "title": "White / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "White",
        "Adult XXL"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754299146430",
      "title": "White / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "White"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "White",
        "Adult XXXL"
      ],
      "mediaId": "33248147308734"
    },
    {
      "id": "47754299179198",
      "title": "Black / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Black",
        "Youth L"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299211966",
      "title": "Black / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Black",
        "Youth XL"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299244734",
      "title": "Black / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Black",
        "Adult S"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299277502",
      "title": "Black / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Black",
        "Adult M"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299310270",
      "title": "Black / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Black",
        "Adult L"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299343038",
      "title": "Black / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Black",
        "Adult XL"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299375806",
      "title": "Black / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXL"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299408574",
      "title": "Black / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Black"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Black",
        "Adult XXXL"
      ],
      "mediaId": "33248147341502"
    },
    {
      "id": "47754299441342",
      "title": "Fluorescent Orange / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Youth L"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299474110",
      "title": "Fluorescent Orange / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Youth XL"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299506878",
      "title": "Fluorescent Orange / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult S"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299539646",
      "title": "Fluorescent Orange / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult M"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299572414",
      "title": "Fluorescent Orange / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult L"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299605182",
      "title": "Fluorescent Orange / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult XL"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299637950",
      "title": "Fluorescent Orange / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult XXL"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299670718",
      "title": "Fluorescent Orange / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Orange"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Fluorescent Orange",
        "Adult XXXL"
      ],
      "mediaId": "33248147374270"
    },
    {
      "id": "47754299703486",
      "title": "Red / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Red",
        "Youth L"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299736254",
      "title": "Red / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Red",
        "Youth XL"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299769022",
      "title": "Red / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Red",
        "Adult S"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299801790",
      "title": "Red / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Red",
        "Adult M"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299834558",
      "title": "Red / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Red",
        "Adult L"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299867326",
      "title": "Red / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Red",
        "Adult XL"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299900094",
      "title": "Red / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXL"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299932862",
      "title": "Red / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Red"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Red",
        "Adult XXXL"
      ],
      "mediaId": "33248147407038"
    },
    {
      "id": "47754299965630",
      "title": "Klein Blue / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Klein Blue",
        "Youth L"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754299998398",
      "title": "Klein Blue / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Klein Blue",
        "Youth XL"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300031166",
      "title": "Klein Blue / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult S"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300063934",
      "title": "Klein Blue / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult M"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300096702",
      "title": "Klein Blue / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult L"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300129470",
      "title": "Klein Blue / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult XL"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300162238",
      "title": "Klein Blue / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult XXL"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300195006",
      "title": "Klein Blue / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Klein Blue"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Klein Blue",
        "Adult XXXL"
      ],
      "mediaId": "33248147439806"
    },
    {
      "id": "47754300227774",
      "title": "Fluorescent Yellow / Youth L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Youth L"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Youth L"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300260542",
      "title": "Fluorescent Yellow / Youth XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Youth XL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Youth XL"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300293310",
      "title": "Fluorescent Yellow / Adult S",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult S"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult S"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300326078",
      "title": "Fluorescent Yellow / Adult M",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult M"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult M"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300358846",
      "title": "Fluorescent Yellow / Adult L",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult L"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult L"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300391614",
      "title": "Fluorescent Yellow / Adult XL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult XL"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300424382",
      "title": "Fluorescent Yellow / Adult XXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult XXL"
      ],
      "mediaId": "33248147472574"
    },
    {
      "id": "47754300457150",
      "title": "Fluorescent Yellow / Adult XXXL",
      "availableForSale": true,
      "options": [
        {
          "name": "Color",
          "value": "Fluorescent Yellow"
        },
        {
          "name": "Size",
          "value": "Adult XXXL"
        }
      ],
      "values": [
        "Fluorescent Yellow",
        "Adult XXXL"
      ],
      "mediaId": "33248147472574"
    }
  ],
  "singleVariant": false
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) {
      return input.value || '';
    });
  }
  function selectedEntry(scope) {
    var values = selectedValues(scope);
    var variant = config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    });
    return variant ? config.entries.find(function (entry) { return entry.id === variant.mediaId; }) : null;
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (item) {
      return item.values.length === values.length && item.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function syncPurchase(scope) {
    var variant = selectedVariant(scope);
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
      var label = button.querySelector('span') || button;
      if (variant.availableForSale && /solds*out|unavailable/i.test(label.textContent || '')) label.textContent = 'Add to Cart';
      if (!variant.availableForSale && /adds*tos*cart/i.test(label.textContent || '')) label.textContent = 'Sold Out';
    });
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncVisualChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name^="options["]');
      if (!input) return;
      var optionMatch = String(input.name || '').match(/^options\[(.+)\]$/);
      if (!optionMatch) return;
      var optionName = optionMatch[1];
      var mediaIds = config.variants.filter(function (variant) {
        return (variant.options || []).some(function (option) {
          return option.name === optionName && option.value === input.value;
        });
      }).map(function (variant) { return variant.mediaId; }).filter(Boolean).filter(function (id, index, all) {
        return all.indexOf(id) === index;
      });
      if (mediaIds.length !== 1) return;
      var entry = config.entries.find(function (item) { return item.id === mediaIds[0]; });
      if (!entry) return;
      var swatch = choice.querySelector('.auto-product__swatch-image');
      if (!swatch) {
        swatch = document.createElement('span');
        swatch.className = 'auto-product__swatch-image';
        swatch.setAttribute('aria-label', input.value || entry.alt || '');
        (choice.querySelector('[data-auto-choice-label]') || choice).appendChild(swatch);
      }
      var image = swatch.querySelector('img');
      if (!image) {
        image = document.createElement('img');
        image.width = 72;
        image.height = 72;
        image.loading = 'lazy';
        swatch.appendChild(image);
      }
      image.src = sized(entry.src, 180);
      image.srcset = '';
      image.alt = input.value || entry.alt || '';
      choice.setAttribute('data-variant-media-id', entry.id);
    });
  }
  function syncSingleVariantLegend(scope) {
    if (!config.singleVariant) return;
    scope.querySelectorAll('.auto-product__option legend').forEach(function (legend) {
      legend.style.setProperty('justify-content', 'flex-start', 'important');
      legend.style.setProperty('align-items', 'center', 'important');
      legend.style.setProperty('gap', '16px', 'important');
      legend.style.setProperty('width', 'fit-content', 'important');
      legend.style.setProperty('max-width', '100%', 'important');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    if (!thumb.querySelector('img')) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.motorbikeGalleryBound !== 'true') {
      thumb.dataset.motorbikeGalleryBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(scope, entry);
        scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
          node.classList.toggle('is-active', node === thumb);
        });
      });
    }
    return thumb;
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var desiredSafeIds = '|' + config.entries.map(function (entry) { return entry.id; }).join('|') + '|';
    if (scope.getAttribute('data-safe-gallery-media-ids') !== desiredSafeIds) {
      scope.setAttribute('data-safe-gallery-media-ids', desiredSafeIds);
    }
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.hidden = false;
      thumb.style.display = '';
      thumb.setAttribute('aria-hidden', 'false');
    });
    syncVisualChoices(scope);
    syncSingleVariantLegend(scope);
    syncPurchase(scope);
    setMain(scope, selectedEntry(scope));
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.motorbikeBackpackGalleryRestoreBound === 'true') return;
    scope.dataset.motorbikeBackpackGalleryRestoreBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(function () {
          hydrate();
          setMain(scope, selectedEntry(scope));
          syncPurchase(scope);
        }, delay);
      });
    });
    var observer = new MutationObserver(function (records) {
      if (applying) return;
      var changed = records.some(function (record) { return record.addedNodes.length || record.removedNodes.length; });
      if (changed) window.setTimeout(hydrate, 20);
    });
    observer.observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-safe-gallery-media-ids'] });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
  window.setInterval(hydrate, 1200);
})();
// END motorbikeBackpackGalleryRestore20260716
